<script lang="ts">
  export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'success' | 'warning' | 'ghost';
  export type ButtonSize = 'sm' | 'md' | 'lg';

  let {
    variant = 'primary',
    size = 'md',
    disabled = false,
    type = 'button',
    onclick = undefined as (() => void) | undefined,
    children
  }: {
    variant?: ButtonVariant;
    size?: ButtonSize;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    onclick?: () => void;
    children: any;
  } = $props();
</script>

<button
  class="btn"
  class:primary={variant === 'primary'}
  class:secondary={variant === 'secondary'}
  class:danger={variant === 'danger'}
  class:success={variant === 'success'}
  class:warning={variant === 'warning'}
  class:ghost={variant === 'ghost'}
  class:sm={size === 'sm'}
  class:md={size === 'md'}
  class:lg={size === 'lg'}
  {disabled}
  {type}
  {onclick}
>
  {@render children()}
</button>

<style lang="scss">
  .btn {
    border: none;
    border-radius: var(--radius-md);
    font-weight: var(--font-weight-semibold);
    cursor: pointer;
    transition: all var(--transition-fast);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm);
    white-space: nowrap;

    &:disabled {
      opacity: var(--opacity-disabled);
      cursor: not-allowed;
    }

    // Sizes
    &.sm {
      padding: var(--spacing-sm) var(--spacing-md);
      font-size: var(--font-size-xs);
    }

    &.md {
      padding: var(--spacing-sm) var(--spacing-lg);
      font-size: var(--font-size-base);
    }

    &.lg {
      padding: var(--spacing-md) var(--spacing-2xl);
      font-size: var(--font-size-xl);
    }

    // Variants
    &.primary {
      background: var(--color-primary);
      color: white;

      &:hover:not(:disabled) {
        background: var(--color-primary-hover);
      }
    }

    &.secondary {
      background: var(--color-text-tertiary);
      color: white;

      &:hover:not(:disabled) {
        background: var(--color-text-secondary);
      }
    }

    &.danger {
      background: var(--color-danger);
      color: white;

      &:hover:not(:disabled) {
        background: var(--color-danger-hover);
      }
    }

    &.success {
      background: var(--color-success);
      color: white;

      &:hover:not(:disabled) {
        background: var(--color-success-hover);
      }
    }

    &.warning {
      background: var(--color-warning);
      color: white;

      &:hover:not(:disabled) {
        background: var(--color-warning-hover);
      }
    }

    &.ghost {
      background: transparent;
      color: var(--color-text-secondary);
      border: var(--border-width-thin) solid var(--color-border);

      &:hover:not(:disabled) {
        background: var(--color-background-tertiary);
        border-color: var(--color-text-muted);
      }
    }
  }
</style>
